import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import classes from './index.module.scss'

export const List = ({ data, onTab, changeTab }) => {
  return (
    <ul style={{ position: 'sticky', top: 0 }}>
      {data?.map((item) => (
        <Element
          key={item.key}
          elementName="li"
          className={classes.rowMain}
          onClick={() => changeTab(item.key)}
          style={
            onTab === item.key
              ? {
                  color: '#FFFFFF',
                  backgroundColor: '#2C73E8',
                  textShadow: 'currentcolor 0px 0px 0.3px',
                  borderColor: '#2C73E8',
                }
              : {
                  color: '#191D25',
                  backgroundColor: '#F3F3F3',
                  fontWeight: 400,
                  borderColor: '#e5e5e5',
                }
          }
        >
          {item.isI18n ? <Translate value={item.label} /> : item.label}
        </Element>
      ))}
    </ul>
  )
}
